import type { InsuranceOfferWithSelectedState } from '@backmarket/http-api'

import { DEFAULT_INSURANCE_ID } from '../../constants'

export function isDefaultOfferSelected(
  insuranceOffer: InsuranceOfferWithSelectedState,
) {
  return (
    insuranceOffer.id.toString() === DEFAULT_INSURANCE_ID &&
    insuranceOffer.selected
  )
}
